import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  errorIconAlt: {
    id: 'portal.views.logistration.notifications.errorIcon.alt',
    defaultMessage: 'Error icon',
    description: 'Alt text for error icon',
  },
  successIconAlt: {
    id: 'portal.views.logistration.notifications.successIcon.alt',
    defaultMessage: 'Success icon',
    description: 'Alt text for success icon',
  },
  closeIconAlt: {
    id: 'portal.views.logistration.notifications.closeIcon.alt',
    defaultMessage: 'Close icon',
    description: 'Alt text for close icon',
  },
});

export default messages;
